import { GET_OPENED_ROOM_ID, GetOpenedRoomIdApi } from '@weblite-wapps/protocol'
import { wappSubscription } from '$logic/wapp-communication/helper/subscription-handler'
import { getOpenedRoomId } from '$logic/opened-room'

wappSubscription.subscribe<GetOpenedRoomIdApi>(GET_OPENED_ROOM_ID, async () => {
  return getOpenedRoomId()
})
